import './shippingOptions.css'

import { useEffect } from 'react'

import shippingIcon from '../../../imgs/delivery.png'
import homeIcon from '../../../imgs/home1.png'
import storeIcon from '../../../imgs/shop.png'

export default function ShippingOptions({ pricesObj, setSelectedShippingMethod, getItemPrice }) {
  useEffect(() => {
    document.getElementById('shipment-radio2').checked = true
    setSelectedShippingMethod('doorToDoor')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ul className='shipping-options-list'>
      <div className='payment-title-cont'>
        <img src={shippingIcon} className='payment-title-img' />
        <h4 className='page-subtitle'>סוג משלוח</h4>
      </div>
      <li className='list-item'>
        <div style={{ textAlign: 'right' }}>
          <input
            onChange={() => setSelectedShippingMethod('doorToDoor')}
            value={pricesObj.doorToDoor}
            type='radio'
            aria-label='radio 1'
            name='shipment-radio'
            id='shipment-radio2'
            style={{ height: '15px', width: '15px' }}
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <img src={homeIcon} className='so-icon' />
        </div>
        <div>
          <span className='list-item-title'>משלוח עד הבית</span>
          <br />
          זמני השילוח הם בין 4-21 ימים מרגע התשלום על השילוח באתר.
          {/* לאחר שתשלמו על המשלוח תקבלו הודעה המבקשת מכם לבחור נקודת חלוקה באיזור
            מגוריכם . אופציה זמינה עד 5 ק״ג משקל פיזי. זמני השילוח הם בין 14-21
            ימים מרגע התשלום על השילוח באתר. מבטיחים שנצליח להפתיע אתכם לטובה אבל
            אנחנו חייבים טווח בטיחות. */}
        </div>
        {/* <div className="price-button">
          <div className="so-price">{getItemPrice('doorToDoor')}</div>
        </div> */}
        <div style={{ fontSize: '19px', fontWeight: 'bold', textAlign: 'center' }}>{getItemPrice('doorToDoor')}</div>
      </li>

      <li className='list-item'>
        <div style={{ textAlign: 'right' }}>
          <input
            value={pricesObj.pickUpPoint ? pricesObj.pickUpPoint : ''}
            onChange={() => setSelectedShippingMethod('pickUpPoint')}
            disabled={!pricesObj.pickUpPoint}
            type='radio'
            aria-label='radio 1'
            name='shipment-radio'
            id='shipment-radio1'
            style={{ height: '15px', width: '15px' }}
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <img src={storeIcon} className='so-icon' />
        </div>
        <div>
          <span className='list-item-title'>משלוח לנקודת חלוקה</span>
          <br />
          {!pricesObj.pickUpPoint ? (
            <div style={{ color: 'red' }}>החבילה גדולה / כבדה מדי בשביל משלוח זה</div>
          ) : (
            <div>זמני השילוח הם בין 4-21 ימים מרגע התשלום על השילוח באתר.</div>
          )}
        </div>
        {/* <div className="price-button">
          <div className="so-price">{getItemPrice('pickUpPoint')}</div>
        </div> */}
        <div style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>{getItemPrice('pickUpPoint')}</div>
      </li>
    </ul>
  )
}
